export function common() {
  // 共通処理をここに記述
}